module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAABmJLR0QA/wD/AP+gvaeTAAAAtUlEQVRoge3Ruw3CQBBF0Wu+ApqgCUKoyRmUAJk7oQ+IKcYiMDkElj0Db5HejUezc7TgXKiqb6C5td2XXr7Uu+UpumaSccvQ1osKOo7NvT1Hd0kAh+2UTRJCAljNK/ZJCAkA8hAyAOQgpACII+QAiCGKAMB4RDEAGIcoCgCfiL752S+Oeu/6eKbtKu4HhmaAOgPUGaDOAHUGqDNAnQHqDFBngDoD1BmgzgB1BqgzQN3fA5wL9gL4YDS54qLgLwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/contentTypes/icons8-file-48.png
// module id = RwVr
// module chunks = 1